import { AuditEffects } from './audit.effects';

export const effects: any[] = [AuditEffects];

export * from './audit.effects';
